export const INSTAGRAM_URL = 'https://www.instagram.com/ccamila_nnails'
export const TIKTOK_URL = 'https://www.tiktok.com/@ccamila_nnails'
export const WHATSAPP_URL = 'https://wa.me/59800000000?text=Hola%20Cami!%20Quiero%20agendar%20un%20turno'
/* Reemplazar por el link real de Calendly del estudio */
export const CALENDLY_URL = 'https://calendly.com/tu-usuario/cami-nails'

/* Horarios base del estudio — luego se sincronizan con la disponibilidad real de Calendly */
export const timeSlots = ['09:00', '10:30', '12:00', '14:00', '15:30', '17:00', '18:30']

export type Service = {
  id: string
  title: string
  icon: 'sparkle' | 'brush' | 'shield' | 'star'
  description: string
  price: string
  note: string
  featured?: boolean
  /* Contenido del "Leer más" */
  longDescription: string[]
  duration: string
  includes: string[]
  image: string
  imageAlt: string
}

export const services: Service[] = [
  {
    id: 'soft-gel',
    title: 'Soft Gel',
    icon: 'sparkle',
    description:
      'Fortalecimiento y largo natural con acabado impecable. Ideal para uñas débiles. Duración: 3 a 4 semanas.',
    price: '$1.200 UYU',
    note: 'Incluye diseño básico',
    featured: true,
    longDescription: [
      'El soft gel es una extensión con tips de gel blando que se adhieren a la uña natural sin limar en exceso la superficie. Es la técnica más liviana y flexible del mercado: suma largo y resistencia respetando la curvatura real de tu mano.',
      'El turno arranca con diagnóstico de la lámina y cutícula, prolijado en seco con torno esterilizado, elección del tip según la forma que quieras (almendra, coffin o cuadrada) y construcción del apex para que el largo no se quiebre. Cierro con esmaltado en gel y aceite de cutícula.',
    ],
    duration: 'Turno de 2 h · Duración del trabajo: 3 a 4 semanas',
    includes: [
      'Diagnóstico y prolijado de cutícula en seco',
      'Extensión con tips de gel blando y apex reforzado',
      'Esmaltado en gel + diseño básico a elección',
      'Retoque de cortesía dentro de las 72 h',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/kkg2aKWCfdj7qzkYmDb5yL/Unitas_coquette_🎀✨Realizamos_Soft_gel_del_bien_🙌🏻_denle_amor_a_la_publi_si_les_gustan_mis_tra.jpg',
    imageAlt:
      'Resultado de soft gel en tono nude con moños en relieve, perlas y cristales',
  },
  {
    id: 'semipermanente',
    title: 'Esmaltado Semipermanente',
    icon: 'brush',
    description:
      'Color perfecto que dura 21 días sin desprenderse. Aplicación profesional y acabado brillante.',
    price: '$800 UYU',
    note: 'Color a elección',
    longDescription: [
      'Esmaltado en gel curado en lámpara LED, capa por capa, sobre tu uña natural. Ideal si te gusta el largo que ya tenés y querés un color parejo, intenso y con brillo espejo que no se descascare durante tres semanas.',
      'Trabajo con deshidratación y primer sin ácido para asegurar la adherencia, sellado del borde libre para evitar desprendimientos y capa top de larga duración. Podés elegir entre más de sesenta colores de marcas certificadas.',
    ],
    duration: 'Turno de 1 h 15 min · Duración del trabajo: 21 días',
    includes: [
      'Limado, prolijado y tratamiento de cutícula',
      'Preparación con primer sin ácido',
      'Dos capas de color + top coat de larga duración',
      'Más de 60 colores para elegir en el estudio',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/7h6B7cW9sdrVRrvMqkxJnD/✨Aqui_les_dejo_mas_de_mis_trabajos✨💅🏻🌈_Gracias_a_todas_por_confiar_en_mi_💕Agendando_Setiembr_(1).jpg',
    imageAlt:
      'Resultado de esmaltado semipermanente en azul eléctrico con acabado brillante y detalle metalizado',
  },
  {
    id: 'kapping',
    title: 'Kapping Gel',
    icon: 'shield',
    description:
      'Protección y fortalecimiento para uñas débiles o dañadas. Perfecto para procesos de recuperación.',
    price: '$1.000 UYU',
    note: 'Opción natural o nude',
    longDescription: [
      'El kapping es una cobertura de gel constructor sobre la uña natural, sin agregar largo. Se aplica en la medida justa para crear una capa resistente que evita quiebres y acompaña el crecimiento de uñas finas, mordidas o que vienen de un mal retiro.',
      'Es el servicio que más recomiendo para procesos de recuperación: en dos o tres sesiones la lámina gana espesor y podés dejar de esconder las manos. Se puede usar solo, en acabado natural, o con nude y francesitas para un look prolijo de oficina.',
    ],
    duration: 'Turno de 1 h 30 min · Duración del trabajo: 3 a 4 semanas',
    includes: [
      'Evaluación del estado de la lámina',
      'Cobertura con gel constructor sobre uña natural',
      'Acabado natural, nude o francesita',
      'Plan de recuperación con seguimiento entre turnos',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/vkfYy6EnVfw1DBY99Rqnws/Capping_en_su_largo_de_una_natural_💅🏻💫Francesitas_negras_2B_puntitos_2B_relieve_🌸🖤Gracias_por.jpg',
    imageAlt:
      'Resultado de kapping en largo natural con francesitas negras, puntitos y flores en relieve',
  },
  {
    id: 'nail-art',
    title: 'Nail Art Especial',
    icon: 'star',
    description:
      'Diseños a mano alzada, tendencias actuales y personalizados. Exclusivo y único para vos.',
    price: 'Consultar',
    note: 'Desde $1.500',
    longDescription: [
      'Diseños pintados a mano alzada con pinceles de detalle: degradés, efecto aura, cromados, relieves 3D, incrustaciones de cristales y piezas de joyería. Se suma sobre cualquiera de las técnicas base (soft gel, kapping o semipermanente).',
      'Antes del turno charlamos por WhatsApp para definir la idea, la paleta y el nivel de detalle, así reservo el tiempo necesario y te paso el precio exacto. Cada diseño se adapta a la forma de tu uña: nunca sale igual dos veces.',
    ],
    duration: 'Turno de 2 h 30 min en adelante, según el diseño',
    includes: [
      'Asesoramiento previo de diseño y paleta',
      'Arte a mano alzada, cromados y relieves 3D',
      'Cristales y apliques premium',
      'Presupuesto cerrado antes de reservar',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/mTXz4BUP33oeks2jkuNtW2/Unitas_de_colores_siiiii_Amamos_la_primavera🌈✨_Gracias_a_todas_las_que_confian_en_mi_siempre_y.jpg',
    imageAlt:
      'Resultado de nail art con degradés de colores, destellos plateados y cristales',
  },
]

export type Feature = {
  id: string
  icon: 'sterile' | 'bottle' | 'candle'
  title: string
  description: string
}

export const features: Feature[] = [
  {
    id: 'higiene',
    icon: 'sterile',
    title: 'Higiene Garantizada',
    description:
      'Esterilización profesional de cada herramienta, materiales premium de un solo uso y un ambiente impecable en cada turno.',
  },
  {
    id: 'materiales',
    icon: 'bottle',
    title: 'Materiales Premium',
    description:
      'Marcas certificadas, productos no tóxicos y acabados de larga duración que cuidan tu uña natural.',
  },
  {
    id: 'ambiente',
    icon: 'candle',
    title: 'Ambiente Relajado',
    description:
      'Espacio cómodo, música, buena energía y tu momento de autocuidado. Atención personalizada, sin acompañantes.',
  },
]

export type GalleryItem = {
  id: string
  src: string
  alt: string
  span?: boolean
}

export const gallery: GalleryItem[] = [
  {
    id: 'coquette',
    src: 'https://cdn.magicpatterns.com/uploads/kkg2aKWCfdj7qzkYmDb5yL/Unitas_coquette_🎀✨Realizamos_Soft_gel_del_bien_🙌🏻_denle_amor_a_la_publi_si_les_gustan_mis_tra.jpg',
    alt: 'Uñas coquette en soft gel nude con moños, perlas y cristales',
    span: true,
  },
  {
    id: 'francesitas',
    src: 'https://cdn.magicpatterns.com/uploads/vkfYy6EnVfw1DBY99Rqnws/Capping_en_su_largo_de_una_natural_💅🏻💫Francesitas_negras_2B_puntitos_2B_relieve_🌸🖤Gracias_por.jpg',
    alt: 'Kapping en largo natural con francesitas negras, puntitos y flores en relieve',
  },
  {
    id: 'colores',
    src: 'https://cdn.magicpatterns.com/uploads/mTXz4BUP33oeks2jkuNtW2/Unitas_de_colores_siiiii_Amamos_la_primavera🌈✨_Gracias_a_todas_las_que_confian_en_mi_siempre_y.jpg',
    alt: 'Uñas de colores pastel con destellos plateados y cristales',
  },
  {
    id: 'rojo',
    src: 'https://cdn.magicpatterns.com/uploads/mpBAcDwPVBWU6CQ83m8LbQ/Mis_10_trabajos_favs_de_Junio_💅🏻💫🫶🏻Cual_te_gusto_mas_Te_leo_👀💕unas_nails_manicura_na.jpg',
    alt: 'Uñas almendradas en rojo marmolado y negro brillante',
  },
  {
    id: 'azul',
    src: 'https://cdn.magicpatterns.com/uploads/7h6B7cW9sdrVRrvMqkxJnD/✨Aqui_les_dejo_mas_de_mis_trabajos✨💅🏻🌈_Gracias_a_todas_por_confiar_en_mi_💕Agendando_Setiembr_(1).jpg',
    alt: 'Uñas azul eléctrico con detalles metalizados a mano alzada',
  },
  {
    id: 'estudio',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/cd655005-f88f-4400-9971-1496d3b6b640.jpg',
    alt: 'Interior del estudio de uñas con mesa blanca, lámpara y esmaltes en tonos rosados',
  },
]

export type Testimonial = {
  id: string
  name: string
  initials: string
  service: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    id: 'lucia',
    name: 'Lucía Fernández',
    initials: 'LF',
    service: 'Soft Gel',
    quote:
      'Tenía las uñas muy débiles y con el soft gel de Cami las recuperé por completo. Me duran cuatro semanas impecables y siempre salgo con una sonrisa.',
  },
  {
    id: 'valentina',
    name: 'Valentina Rodríguez',
    initials: 'VR',
    service: 'Nail Art Especial',
    quote:
      'Le mostré una foto de referencia y me hizo algo mucho mejor. El detalle a mano alzada es otro nivel, y el ambiente del estudio es súper relajado.',
  },
  {
    id: 'sofia',
    name: 'Sofía Martínez',
    initials: 'SM',
    service: 'Semipermanente',
    quote:
      'Puntualidad, higiene impecable y un color que después de 21 días seguía como el primer día. Ya es mi lugar fijo en el Prado.',
  },
]
